import { FieldDescriptor } from "@crispico/foundation-react";

export class TotalQuantityFieldDescriptor extends FieldDescriptor {
    constructor() {
        super();
        this.clientOnly = true;
        this.filterable = false;
        this.sortable = false;
        this.enabled = false;
    }

    getAppearsInUi() {
        return true;
    }

    renderField(entity: any) {
        const totalQuantity = entity["quantity"] + (entity["debords"] ? entity["debords"] / 2 : 0);
        return <span>{totalQuantity}</span>;
    }
}